module.exports = __webpack_public_path__ + "img/adminconsole.e31ea70a.svg";